var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: "Cập nhật tin tức",
            size: "xl",
            top: "20px",
            "close-on-click-modal": false,
            "panel-icon": "el-icon-edit-outline",
            "panel-title": "Cập nhật tin tức",
            "panel-subtitle": "Điều chỉnh nội dung, tệp đính kèm và lịch gửi",
          },
          on: { "update:visible": _vm.handleVisibleUpdate },
        },
        [
          _c(
            "el-form",
            {
              ref: "updateData",
              staticClass: "notify-two-col-form",
              attrs: {
                model: _vm.fromData,
                rules: _vm.rules,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 15 } }, [
                    _c(
                      "div",
                      { staticClass: "left-form-pane" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "title",
                              label: "Tiêu đề thông báo",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "Nhập tiêu đề thông báo...",
                                clearable: "",
                              },
                              model: {
                                value: _vm.fromData.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.fromData, "title", $$v)
                                },
                                expression: "fromData.title",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Nội dung thông báo",
                              prop: "content",
                            },
                          },
                          [
                            _c("div", { staticClass: "content-toolbar" }, [
                              _c(
                                "div",
                                { staticClass: "mode-switch-group" },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      attrs: { size: "mini" },
                                      model: {
                                        value: _vm.contentViewMode,
                                        callback: function ($$v) {
                                          _vm.contentViewMode = $$v
                                        },
                                        expression: "contentViewMode",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "editor" } },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-edit",
                                          }),
                                          _vm._v(
                                            " Soạn thảo\n                    "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "preview" } },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-view",
                                          }),
                                          _vm._v(
                                            " Xem thực tế\n                    "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "source" } },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-tickets",
                                          }),
                                          _vm._v(
                                            " Mã nguồn HTML\n                    "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "dialog-switch-group" },
                                [
                                  _vm.contentViewMode === "preview"
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                            plain: "",
                                            icon: "el-icon-full-screen",
                                          },
                                          on: {
                                            click: _vm.handleOpenPreviewDialog,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Mở cửa sổ lớn\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.contentViewMode === "source"
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "warning",
                                            plain: "",
                                            icon: "el-icon-document-copy",
                                          },
                                          on: {
                                            click: _vm.handleCopyHtmlSource,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Sao chép mã\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.contentViewMode === "source"
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "info",
                                            plain: "",
                                            icon: "el-icon-full-screen",
                                          },
                                          on: {
                                            click: _vm.handleOpenSourceDialog,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Cửa sổ mã nguồn\n                  "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.contentViewMode === "editor",
                                    expression: "contentViewMode === 'editor'",
                                  },
                                ],
                              },
                              [
                                _c("TextEditor", {
                                  ref: "textEditor",
                                  attrs: { height: "380px" },
                                  model: {
                                    value: _vm.fromData.content,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fromData, "content", $$v)
                                    },
                                    expression: "fromData.content",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.contentViewMode === "preview",
                                    expression: "contentViewMode === 'preview'",
                                  },
                                ],
                                staticClass: "html-preview-container",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "preview-device-card" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "preview-card-header" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "preview-title" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.fromData.title ||
                                                  "Tiêu đề thông báo"
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "success",
                                            },
                                          },
                                          [_vm._v("Xem thực tế")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "preview-card-body" },
                                      [
                                        _vm.fromData.content
                                          ? _c("div", {
                                              staticClass:
                                                "html-content-render",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.fromData.content
                                                ),
                                              },
                                            })
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "preview-empty-text",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-document-remove",
                                                }),
                                                _vm._v(
                                                  " Chưa có nội dung để hiển thị\n                    "
                                                ),
                                              ]
                                            ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.contentViewMode === "source",
                                    expression: "contentViewMode === 'source'",
                                  },
                                ],
                                staticClass: "html-source-container",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "source-code-header" },
                                  [
                                    _c("span", { staticClass: "source-info" }, [
                                      _c("i", {
                                        staticClass: "el-icon-tickets",
                                      }),
                                      _vm._v(
                                        " Mã nguồn HTML (có thể xem và chỉnh sửa):"
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("el-input", {
                                  staticClass: "source-code-textarea",
                                  attrs: {
                                    type: "textarea",
                                    rows: 15,
                                    placeholder: "Mã nguồn HTML...",
                                  },
                                  model: {
                                    value: _vm.fromData.content,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.fromData, "content", $$v)
                                    },
                                    expression: "fromData.content",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "link",
                              label: "Đường dẫn liên kết đính kèm",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "https://example.com...",
                                "prefix-icon": "el-icon-link",
                                clearable: "",
                              },
                              model: {
                                value: _vm.fromData.link,
                                callback: function ($$v) {
                                  _vm.$set(_vm.fromData, "link", $$v)
                                },
                                expression: "fromData.link",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 9 } }, [
                    _c("div", { staticClass: "right-form-pane" }, [
                      _c("div", { staticClass: "notify-card-box" }, [
                        _c("div", { staticClass: "card-box-header" }, [
                          _c("i", { staticClass: "el-icon-s-custom" }),
                          _c("span", { staticClass: "card-title" }, [
                            _vm._v("Phạm vi nhận tin"),
                          ]),
                        ]),
                        _c("div", { staticClass: "card-box-body" }, [
                          _c(
                            "div",
                            { staticClass: "nfs-scope-selector" },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "w-full",
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "Chọn phạm vi" },
                                  on: { change: _vm.handleChangeScopeApply },
                                  model: {
                                    value: _vm.scopeForm,
                                    callback: function ($$v) {
                                      _vm.scopeForm = $$v
                                    },
                                    expression: "scopeForm",
                                  },
                                },
                                _vm._l(
                                  _vm.listScopeApply,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "nfs-scope-buttons",
                              staticStyle: {
                                "margin-top": "10px",
                                display: "flex",
                                gap: "8px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "nfs-choice-btn",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    type: _vm.isShowButtonScope.class
                                      ? "primary"
                                      : "info",
                                    size: "small",
                                    plain: true,
                                    disabled: !_vm.isShowButtonScope.class,
                                    icon: "el-icon-folder",
                                  },
                                  on: { click: _vm.handleShowApplyKid },
                                },
                                [
                                  _vm._v(
                                    "\n                    Chọn Lớp (" +
                                      _vm._s(_vm.applyForm.kids.length) +
                                      ")\n                  "
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "nfs-choice-btn",
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    type: _vm.isShowButtonScope.employee
                                      ? "primary"
                                      : "info",
                                    size: "small",
                                    plain: true,
                                    disabled: !_vm.isShowButtonScope.employee,
                                    icon: "el-icon-user-solid",
                                  },
                                  on: { click: _vm.handleShowApplyEmployee },
                                },
                                [
                                  _vm._v(
                                    "\n                    Nhân sự (" +
                                      _vm._s(_vm.applyForm.employees.length) +
                                      ")\n                  "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "nfs-scope-lists",
                              staticStyle: { "margin-top": "10px" },
                            },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 8 } },
                                [
                                  _c("el-col", { attrs: { span: 12 } }, [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "nfs-scope-list-box",
                                          {
                                            "is-disabled":
                                              !_vm.isShowButtonScope.class,
                                          },
                                        ],
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "nfs-list-box-title" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "title-left" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-folder-opened",
                                                  staticStyle: {
                                                    color: "#eab308",
                                                    "font-size": "15px",
                                                  },
                                                }),
                                                _c("span", [
                                                  _vm._v(
                                                    "Học sinh (" +
                                                      _vm._s(
                                                        _vm.applyForm.kids
                                                          .length
                                                      ) +
                                                      ")"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "nfs-title-tag" },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.scopeForm === "all"
                                                        ? "Tất cả"
                                                        : _vm.scopeForm ===
                                                          "class"
                                                        ? "Lớp học"
                                                        : "Tất cả"
                                                    ) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.applyForm.kids.length
                                                    ) +
                                                    ")\n                          "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "nfs-list-box-content",
                                          },
                                          [
                                            _vm.applyForm.kids.length > 0
                                              ? _vm._l(
                                                  _vm.applyForm.kids,
                                                  function (kid, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "nfs-apply-pill",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-circle-check text-green-500",
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              kid.kidsName ||
                                                                kid.kidName ||
                                                                kid.fullName
                                                            )
                                                          ),
                                                          kid.className
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  " (" +
                                                                    _vm._s(
                                                                      kid.className
                                                                    ) +
                                                                    ")"
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "nfs-no-selection",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          _vm.isShowButtonScope
                                                            .class
                                                            ? "Chưa chọn học sinh nào"
                                                            : "Chưa chọn"
                                                        ) +
                                                        "\n                          "
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("el-col", { attrs: { span: 12 } }, [
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          "nfs-scope-list-box",
                                          {
                                            "is-disabled":
                                              !_vm.isShowButtonScope.employee,
                                          },
                                        ],
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "nfs-list-box-title" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "title-left" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-s-custom",
                                                  staticStyle: {
                                                    color: "#2563eb",
                                                    "font-size": "15px",
                                                  },
                                                }),
                                                _c("span", [
                                                  _vm._v(
                                                    "Nhân sự (" +
                                                      _vm._s(
                                                        _vm.applyForm.employees
                                                          .length
                                                      ) +
                                                      ")"
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "nfs-title-tag" },
                                              [
                                                _vm._v(
                                                  "\n                            " +
                                                    _vm._s(
                                                      _vm.scopeForm === "all"
                                                        ? "Tất cả"
                                                        : _vm.scopeForm ===
                                                          "employee"
                                                        ? "Nhân sự"
                                                        : "Tất cả"
                                                    ) +
                                                    " (" +
                                                    _vm._s(
                                                      _vm.applyForm.employees
                                                        .length
                                                    ) +
                                                    ")\n                          "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "nfs-list-box-content",
                                          },
                                          [
                                            _vm.applyForm.employees.length > 0
                                              ? _vm._l(
                                                  _vm.applyForm.employees,
                                                  function (employee, index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index,
                                                        staticClass:
                                                          "nfs-apply-pill",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-circle-check text-green-500",
                                                        }),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              employee.teacherName ||
                                                                employee.fullName ||
                                                                employee.employeeName
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "nfs-no-selection",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                            " +
                                                        _vm._s(
                                                          _vm.isShowButtonScope
                                                            .employee
                                                            ? "Chưa chọn nhân sự nào"
                                                            : "Chưa chọn"
                                                        ) +
                                                        "\n                          "
                                                    ),
                                                  ]
                                                ),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "notify-card-box" }, [
                        _c("div", { staticClass: "card-box-header" }, [
                          _c("i", { staticClass: "el-icon-time" }),
                          _c("span", { staticClass: "card-title" }, [
                            _vm._v("Thời gian gửi"),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "card-box-body" },
                          [
                            _vm.isSent
                              ? [
                                  _c(
                                    "el-tag",
                                    { attrs: { type: "info", size: "medium" } },
                                    [
                                      _c("i", { staticClass: "el-icon-info" }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatNotifySendStatus(
                                              _vm.fromData.sendType
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm._f("formatDateTime")(
                                              _vm.fromData.scheduledTime
                                            )
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              : [
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticClass: "send-type-segmented",
                                      attrs: { size: "small" },
                                      on: { change: _vm.handleSendTypeChange },
                                      model: {
                                        value: _vm.fromData.sendType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.fromData,
                                            "sendType",
                                            $$v
                                          )
                                        },
                                        expression: "fromData.sendType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "IMMEDIATE" } },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-s-promotion",
                                          }),
                                          _vm._v(" Gửi ngay"),
                                        ]
                                      ),
                                      _c(
                                        "el-radio-button",
                                        { attrs: { label: "SCHEDULED" } },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-date",
                                          }),
                                          _vm._v(" Lên lịch gửi"),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.fromData.sendType === "SCHEDULED"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "10px" },
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              type: "datetime",
                                              placeholder: "Chọn ngày giờ gửi",
                                              "picker-options":
                                                _vm.pickerOptions,
                                              size: "small",
                                            },
                                            on: {
                                              focus: _vm.resetScheduledTime,
                                            },
                                            model: {
                                              value: _vm.fromData.scheduledTime,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.fromData,
                                                  "scheduledTime",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "fromData.scheduledTime",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                          ],
                          2
                        ),
                      ]),
                      _c("div", { staticClass: "notify-card-box" }, [
                        _c("div", { staticClass: "card-box-header" }, [
                          _c("i", { staticClass: "el-icon-paperclip" }),
                          _c("span", { staticClass: "card-title" }, [
                            _vm._v("Đính kèm ảnh & tệp"),
                          ]),
                          _c("span", { staticClass: "badge-file-count" }, [
                            _vm._v(
                              "Tổng: " + _vm._s(_vm.totalFiles) + "/3 tệp"
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "card-box-body" },
                          [
                            _c(
                              "div",
                              { staticClass: "upload-drop-section" },
                              [
                                _c("span", { staticClass: "upload-sublabel" }, [
                                  _c("i", {
                                    staticClass: "el-icon-picture-outline",
                                  }),
                                  _vm._v(" Hình ảnh đính kèm:"),
                                ]),
                                _c(
                                  "el-upload",
                                  {
                                    ref: "uploadImg",
                                    staticClass: "drag-dropzone-uploader",
                                    class: {
                                      "hide-trigger": _vm.totalFiles >= 3,
                                    },
                                    attrs: {
                                      drag: "",
                                      action: "/api/upload/",
                                      "list-type": "picture",
                                      "auto-upload": false,
                                      "on-preview":
                                        _vm.handlePictureCardPreview,
                                      "file-list": _vm.imageFileList,
                                      "on-change": _vm.handleChangeImg,
                                      "on-remove": _vm.handleRemoveImg,
                                      accept: ".jpg,.jpeg,.png,.webp",
                                      multiple: "",
                                      limit: 3,
                                      "on-exceed": _vm.handleExceed,
                                      disabled: _vm.totalFiles >= 3,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.resetWaningImg.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-upload" }),
                                    _c(
                                      "div",
                                      { staticClass: "el-upload__text" },
                                      [
                                        _vm._v("Kéo thả ảnh vào đây hoặc "),
                                        _c("em", [_vm._v("chọn tệp")]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "upload-drop-section",
                                staticStyle: { "margin-top": "12px" },
                              },
                              [
                                _c("span", { staticClass: "upload-sublabel" }, [
                                  _c("i", { staticClass: "el-icon-document" }),
                                  _vm._v(" File tài liệu bổ sung:"),
                                ]),
                                _c(
                                  "el-upload",
                                  {
                                    ref: "uploadExcel",
                                    staticClass: "drag-dropzone-file-uploader",
                                    attrs: {
                                      drag: "",
                                      action: "/api/upload/",
                                      "auto-upload": false,
                                      "file-list": _vm.excelFileList,
                                      "on-change": _vm.handleChangeFile,
                                      "on-remove": _vm.handleRemoveExcel,
                                      "on-preview": _vm.downloadItem,
                                      accept:
                                        ".xls,.xlsx,.doc,.docx,.pdf,.txt,.zip,.rar",
                                      multiple: "",
                                      limit: 3,
                                      "on-exceed": _vm.handleExceed,
                                      disabled: _vm.totalFiles >= 3,
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-upload" }),
                                    _c(
                                      "div",
                                      { staticClass: "el-upload__text" },
                                      [
                                        _vm._v("Kéo thả file vào đây hoặc "),
                                        _c("em", [_vm._v("chọn tệp")]),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm.showProgress
                              ? _c("el-progress", {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: {
                                    percentage: _vm.percentage,
                                    color: _vm.colors,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer sk-dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.resetField("updateData")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _c("span", [_vm._v("Đóng")]),
                ]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "success",
                    size: "medium",
                    loading: _vm.loadingButton,
                    mini: "",
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.submitForm("updateData")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-check" }),
                  _c("span", [_vm._v("Lưu")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.dialogVisible1,
            width: "30%",
            "show-footer": false,
            "panel-icon": "el-icon-picture-outline",
            "panel-title": "Xem trước ảnh",
          },
          on: { "update:visible": _vm.handlePreviewVisibleUpdate },
        },
        [
          _c("img", {
            attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
          }),
        ]
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.dialogPreviewHtmlVisible,
            title: "Xem hiển thị nội dung thực tế",
            size: "large",
            top: "30px",
            "append-to-body": true,
            "panel-icon": "el-icon-view",
            "panel-title": "Nội dung thông báo (Thực tế trên Mobile/Web)",
            "panel-subtitle":
              "Kiểm tra bảng biểu, định dạng và hình ảnh trước khi lưu",
          },
          on: {
            "update:visible": (val) => (_vm.dialogPreviewHtmlVisible = val),
          },
        },
        [
          _c("div", { staticClass: "preview-device-card preview-large-box" }, [
            _c(
              "div",
              { staticClass: "preview-card-header" },
              [
                _c("span", { staticClass: "preview-title" }, [
                  _vm._v(_vm._s(_vm.fromData.title || "Tiêu đề thông báo")),
                ]),
                _c("el-tag", { attrs: { size: "mini", type: "success" } }, [
                  _vm._v("Xem thực tế trên ứng dụng"),
                ]),
              ],
              1
            ),
            _c("div", { staticClass: "preview-card-body" }, [
              _vm.fromData.content
                ? _c("div", {
                    staticClass: "html-content-render",
                    domProps: { innerHTML: _vm._s(_vm.fromData.content) },
                  })
                : _c("div", { staticClass: "preview-empty-text" }, [
                    _c("i", { staticClass: "el-icon-document-remove" }),
                    _vm._v(" Chưa có nội dung để hiển thị\n        "),
                  ]),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogPreviewHtmlVisible = false
                    },
                  },
                },
                [_vm._v("Đóng cửa sổ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.dialogSourceHtmlVisible,
            title: "Mã nguồn HTML",
            size: "large",
            top: "30px",
            "append-to-body": true,
            "panel-icon": "el-icon-tickets",
            "panel-title": "Chi tiết mã nguồn HTML",
            "panel-subtitle": "Xem, chỉnh sửa hoặc sao chép mã nguồn HTML",
          },
          on: {
            "update:visible": (val) => (_vm.dialogSourceHtmlVisible = val),
          },
        },
        [
          _c(
            "div",
            { staticClass: "source-dialog-body" },
            [
              _c("el-input", {
                staticClass: "source-code-textarea",
                attrs: {
                  type: "textarea",
                  rows: 18,
                  placeholder: "Mã nguồn HTML...",
                },
                model: {
                  value: _vm.fromData.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.fromData, "content", $$v)
                  },
                  expression: "fromData.content",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "warning",
                    icon: "el-icon-document-copy",
                    size: "small",
                  },
                  on: { click: _vm.handleCopyHtmlSource },
                },
                [_vm._v("Sao chép mã")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogSourceHtmlVisible = false
                    },
                  },
                },
                [_vm._v("Hoàn tất")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("ApplyKidSurveyForm", {
        ref: "applyKidSurveyForm",
        attrs: { "is-open": _vm.isDialogApply.kid },
        on: {
          closeDialog: _vm.handleCloseDialogApplyKid,
          confirmData: _vm.handleConfirmKidsApply,
        },
      }),
      _c("ApplyEmployeeSurveyForm", {
        ref: "applyEmployeeSurveyForm",
        attrs: { "is-open": _vm.isDialogApply.employee },
        on: {
          closeDialog: _vm.handleCloseDialogApplyEmployee,
          confirmData: _vm.handleConfirmEmployeesApply,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }